import { useCallback } from 'react';

import { Spinner } from 'components';

import { CountdownLoader } from './CountdownLoader';

interface LoaderRendererProps {
  loaderUrl?: string;
  imageClassName?: string;
  showCountdown?: boolean;
}

export const LoaderRenderer = ({
  loaderUrl,
  imageClassName = 'tw-w-88 tw-max-h-24 tw-animate-pulse',
  showCountdown = false,
}: LoaderRendererProps) => {
  const renderLoader = useCallback(() => {
    const isCountDown = loaderUrl?.startsWith('custom-countdown-');
    if (showCountdown && isCountDown) {
      const seconds = parseInt(loaderUrl!.replace('custom-countdown-', ''), 10);
      if (!isNaN(seconds)) {
        return <CountdownLoader seconds={seconds} />;
      }
      return <Spinner />;
    }

    if (loaderUrl && !isCountDown) {
      return (
        <img className={imageClassName} src={loaderUrl} alt="logo-loader" />
      );
    }

    return <Spinner />;
  }, [loaderUrl, imageClassName, showCountdown]);

  return <>{renderLoader()}</>;
};
